import axios from "axios"

export const createChatSession = async (payload, token) => {
  try {
    const res = axios.post('api/fastapi/session/', payload, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    return res;
  } catch (error) {
    return error;
  }
}


export const fetchChatSessions = async (id, token) => {
  try {
    const res = await axios.get(`api/fastapi/session-history/?user_id=${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return res;
  } catch (err) {
    if (axios.isAxiosError(err)) {
      throw err.response?.data ?? err;
    }
    throw err;
  }
};

export const sendChatMessage = async (payload, token) => {
  try {
    const res = axios.post('api/fastapi/chat/', payload, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    return res;
  } catch (error) {
    return error;
  }
}

export const fetchChatsHistory = async (session_id, token) => {
  try {
    const res = await axios.get(`api/fastapi/chat-history/${session_id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return res;
  } catch (error) {
    return error;
  }
}

export const uploadDocument = async (payload, token) => {
  const { files, session_id } = payload;
  try {
    const formData = new FormData();
    formData.append("files", files);
    formData.append('session_id', session_id)

    const response = await axios.post("api/fastapi/upload/", formData, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  
    return response.data;
  } catch (error) {
   
    throw error?.response?.data || error;
  }
};

export const updateChatSessionName = async ({
  session_id, new_title, token
}) => {
  try {
    const res = await axios.patch(`api/fastapi/session/${session_id}/rename/`, { new_title }, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    return res;
  }
  catch (error) {
    return error;
  }
};

export const updateSessionArchiveStatus = async ({
  session_id, archived, token
}) => {
  try {
    const res = await axios.patch(`api/fastapi/session/${session_id}/archive/`, { archived }, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    return res;
  }
  catch (error) {
    return error;
  }
};

export const deleteChatSession = async ({
  session_id, token
}) => {
  try {
    const res = await axios.delete(`api/fastapi/session/${session_id}/`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    return res;
  }
  catch (error) {
    return error;
  }
};
